import { render, staticRenderFns } from "./ProductsCategoryQuickAdd.vue?vue&type=template&id=20cadf40&"
import script from "./ProductsCategoryQuickAdd.vue?vue&type=script&lang=js&"
export * from "./ProductsCategoryQuickAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports